(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wc-contact"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.wc-contact__form-col form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('.wc-contact__submit');
      if (btn && !btn.disabled) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wc-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTimeline(section) {
      var list = section.querySelector('.wc-timeline__list');
      if (!list) return;
      var items = Array.prototype.slice.call(list.querySelectorAll('.wc-tl-item'));
      if (!items.length) return;

      var raf = null;
      function getDot(item) { return item.querySelector('.wc-tl-item__dot'); }

      function update() {
        raf = null;
        var firstDot = getDot(items[0]);
        var lastDot = getDot(items[items.length - 1]);
        if (!firstDot || !lastDot) return;

        var listRect = list.getBoundingClientRect();
        var firstRect = firstDot.getBoundingClientRect();
        var lastRect = lastDot.getBoundingClientRect();
        var firstCenter = firstRect.top + firstRect.height / 2;
        var lastCenter = lastRect.top + lastRect.height / 2;

        var lineTop = firstCenter - listRect.top;
        var lineHeight = Math.max(0, lastCenter - firstCenter);
        list.style.setProperty('--wc-tl-line-top', lineTop + 'px');
        list.style.setProperty('--wc-tl-line-height', lineHeight + 'px');

        var naturalAnchor = window.innerHeight * 0.5;
        var sectionRect = section.getBoundingClientRect();
        var lookahead = window.innerHeight * 0.35;
        var sectionBottomOffset = sectionRect.bottom - window.innerHeight;
        var t = 1 - Math.max(0, Math.min(1, sectionBottomOffset / lookahead));
        var anchor = naturalAnchor + t * Math.max(0, lastCenter - naturalAnchor);
        var span = lineHeight || 1;
        var progress = (anchor - firstCenter) / span;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;
        list.style.setProperty('--wc-tl-progress-height', (lineHeight * progress) + 'px');

        var activeIndex = -1;
        for (var i = 0; i < items.length; i++) {
          var dot = getDot(items[i]);
          if (!dot) continue;
          var r = dot.getBoundingClientRect();
          var y = r.top + r.height / 2;
          if (y <= anchor + 4) activeIndex = i;
        }
        if (activeIndex < 0) activeIndex = 0;
        for (var j = 0; j < items.length; j++) {
          items[j].classList.toggle('is-active', j === activeIndex);
        }
      }

      function schedule() {
        if (raf == null) raf = requestAnimationFrame(update);
      }

      update();
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
    }

    document.querySelectorAll('.wc-timeline').forEach(initTimeline);

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.wc-timeline');
      if (section) initTimeline(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wc-trust-marquee"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.wc-trust-marquee__track').forEach(function(track) {
    var set = track.querySelector('.wc-trust-marquee__set');
    if (!set) return;

    var setWidth = set.offsetWidth;
    if (!setWidth) return;

    var needed = Math.max(1, Math.ceil((window.innerWidth * 2) / setWidth));
    for (var i = 0; i < needed; i++) {
      var clone = set.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.classList.add('wc-trust-marquee__set--clone');
      track.appendChild(clone);
    }

    var totalSets = 1 + needed;
    track.style.setProperty('--wc-marquee-scroll', -(100 / totalSets) + '%');
    track.style.animationPlayState = 'running';
  });

  } catch(e) { console.error(e); }
})();
})();
